import pica from "pica";
import imageCompression from "browser-image-compression";

const loadImage = async (src: string): Promise<HTMLImageElement> => {
    const img = new Image();
    img.src = src;

    await new Promise<void>((resolve, reject) => {
        img.onload = () => resolve();
        img.onerror = () => reject(new Error("Image loading failed"));
    });

    return img;
};

const cropImage = (img: HTMLImageElement, crop: any): HTMLCanvasElement => {
    const canvas: HTMLCanvasElement = document.createElement("canvas");
    canvas.width = crop.width;
    canvas.height = crop.height;

    const ctx = canvas.getContext("2d")!;
    ctx.drawImage(
        img,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        crop.width,
        crop.height,
    );
    return canvas;
};

const resizeImage = async (
    canvas: HTMLCanvasElement,
    maxDim: number,
): Promise<HTMLCanvasElement> => {
    if (canvas.width > maxDim || canvas.height > maxDim) {
        const ratio = Math.min(maxDim / canvas.width, maxDim / canvas.height);
        const resized = document.createElement("canvas");
        resized.width = canvas.width * ratio;
        resized.height = canvas.height * ratio;

        await pica().resize(canvas, resized);
        return resized;
    }

    return canvas;
};

const compressImage = async (
    canvas: HTMLCanvasElement,
    maxSizeKB: number,
): Promise<Blob> => {
    const file = await imageCompression.canvasToFile(
        canvas,
        "image/webp",
        "image.webp",
        Date.now(),
    );

    return await imageCompression(file, {
        maxSizeMB: maxSizeKB / 1000,
        useWebWorker: true,
        fileType: "image/webp",
    });
};

const processImage = async (
    img: HTMLImageElement,
    crop: any,
    maxDim: number,
    maxSizeKB: number,
): Promise<Blob> => {
    let canvas = cropImage(img, crop);
    canvas = await resizeImage(canvas, maxDim);
    return await compressImage(canvas, maxSizeKB);
};

export default {
    loadImage,
    processImage,
};
